import React, { Component } from "react";
import Navigation from "./Navigation";
import Dashboard from "../Dashboard";
import MiCompAPI from "../../util/api";
import AllContracts from "../User/AllContracts";
import Broker from "../User/Broker/Broker";
import Transactions from "../Transactions/Transactions";
import Agency from "../User/Agencies/Agency";
import MyProfile from "../myprofile";
import InvoiceAdjustment from "../finance/InvoiceAdjustment";
import Finance from "../finance/finance.jsx";
import MyPlans from "../Plan/MyPlans.jsx";
import ClientProfile from "../User/Client/ClientProfile";
import Client from "../User/Client/Client";
import Subscription from "../Auth/Subscription";
import UserManagement from "../Administration/user_management/UserManagement";
import Settings from "../Administration/Settings";
import InviteLaunchPad from "../User/Registration/InviteLaunchPad";
import AddTierandProfile from "../User/Client/AddTierandProfile";
import ManageReports from "../Administration/ManageReports";
import ManageCompliance from "../Administration/ManageCompliance/ManageCompliance";
import TaxProfile from "../Administration/TaxProfile";
import AgencyCommission from "../Reports/AgencyCommission";
import ClientSummary from "../Reports/ClientSummary";
import BrokerCommission from "../Reports/BrokerCommission";
import BrokerAgencyRecon from "../Reports/BrokerAgencyRecon";
import EnrollmentSummary from "../Reports/EnrollmentSummary";
import AgencyOutstandingPayment from "../Reports/AgencyOutstandingPayment";
import BrokerOutstandingPayment from "../Reports/BrokerOutstandingPayment";
import AgencyComplianceMissing from "../Reports/AgencyComplianceMissing";
import BrokerComplianceMissing from "../Reports/BrokerComplianceMissing";
import AgencyComplianceLicense from "../Reports/AgencyComplianceLicense";
import BrokerComplianceLicense from "../Reports/BrokerComplianceLicense";
import PremiumVSmembers from "../Reports/PremiumVSmembers";
import ComplianceMissing from "../Reports/ComplianceMissing";
import ComplianceLicenseExpiration from "../Reports/ComplianceLicenseExpiration";
import About from "../About";
import Help from "../HelpMenu/Help";
import OutstandingPayment from "../Reports/OutstandingPayment";
import ResetPassword from "./ResetPassword";
import Commission from "../Reports/Commission";
// import ManageTriggers from "../Fields/ManageTriggers";

import {
  Layout,
  Menu,
  message,
  Tag,
  Button,
  Empty,
  Drawer,
  Skeleton,
} from "antd";
import { Link } from "react-router-dom";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Contracts from "../Contracts/MyContracts";
import Book from "../Contracts/Book";
import NiprEligibility from "../User/NIPR/NiprEligibility";

import MyNipr from "../User/NIPR/MyNipr";
import Questions from "../Administration/Questions/Questions";
import BackgroundQuestion from "../Administration/Questions/BackgroundQuestion";
import StateSpecificQuestion from "../Administration/Questions/StateSpecificQuestion";
import NiprPayment from "../User/NIPR/NiprPayment";
import Paypal from "../User/NIPR/Paypal";
import SubscriptionPaypal from "../Auth/SubscriptionPaypal";
import Producermember from "../User/Member/Producermember";
import Family from "../User/Member/Family";
import Enrollment from "../User/Member/Enrollment";

import PlanChange from "../User/Member/PlanChange";
import moment from "moment";
import { Badge, Icon, Row, Col, Avatar, Modal } from "antd";
import Collaboration from "../Collaboration/Collaboration";
import img from "../../assets/img/Illustration.png";
import ManageFields from "../Fields/ManageFields";
import TemplateManagement from "../Fields/TemplateManagement";
import AddTemplate from "../Fields/AddTemplate";
import Discussion from "../DiscussionaBoard/Discussion";
import Providerssearch from "../User/Member/Providerssearch";
import ManageEvent from "../Fields/ManageEvent";
import { ChatClient } from "@azure/communication-chat";
import { AzureCommunicationTokenCredential } from "@azure/communication-common";
import ViewTemplate from "../Fields/ViewTemplate";
import ServiceRequest from "../Fields/ServiceRequest";
import RequestView from "../Fields/RequestView";
import AddRequest from "../Fields/AddRequest";
import NotificationSettings from "../Notifications/NotificationSettings";
import { createUser, getToken } from "../Collaboration/ChatandCall";
import {
  CallClient,
  LocalVideoStream,
  Features,
} from "@azure/communication-calling";
import { v4 as uuid } from "uuid";
import CallCard from "../Collaboration/MakeCall/CallCard";
import IncomingCallCard from "../Collaboration/MakeCall/IncomingCallCard";
import MemberEnquiry from "../Enquirys/MemberEnquiry";
import ContractCarrier from "../CommissionCenter/ContractCarrier";
import CommissionCenter from "../CommissionCenter/CommissionCenter";
import BrokerEnquiry from "../Enquirys/BrokerEnquiry";
import AddEnquiry from "../Enquirys/AddEnquiry";
import simple_sms from "../../assets/simple_sms.mp3";
import AddRequestTemplate from "../Fields/AddRequestTemplate";
import ManageTriggers from "../Fields/ManageTriggers";
import { CommunicationIdentityClient } from "@azure/communication-identity";
import BrokerProfile from "../Administration/BOR/BrokerOfRecord";
import ComplianceTab from "../Administration/Compliance/ComplianceTab";
import OnboardingDetails from "../Reports/OnboardingDetails.jsx";
import { spawn } from "child_process";
import PendingComplianceReport from "../Reports/PendingComplianceReport.jsx";

const { SubMenu } = Menu;
const { Header } = Layout;
const { Content } = Layout;

class Routes extends Component {
  constructor(props) {
    super(props);
    this.chatClient = null;
    this.callClient = null;
    this.debugInfoFeature = null;
    this.environmentInfo = null;
    this.callAgent = null;
    this.deviceManager = null;
    this.videoConstraints = null;
    this.tokenCredential = null;
    this._identityClient = null;
    this.state = {
      collapse: false,
      isMenuEnter: false,
      isMember: false,
      notification: [],
      visible: false,
      addActive: false,
      closeHandler: false,
      notifi: null,
      settingdrawervisible: false,
      loginuser: null,
      isCallClientActiveInAnotherTab: false,
      call: undefined,
      incomingCall: undefined,
      showPreCallDiagnostcisResults: false,
      isPreCallDiagnosticsCallInProgress: false,
      selectedCameraDeviceId: null,
      selectedSpeakerDeviceId: null,
      selectedMicrophoneDeviceId: null,
      ufdMessages: [],
      permissions: {
        audio: null,
        video: null,
      },
      preCallDiagnosticsResults: {},
      serverCallId: undefined,
      thread: null,
    };
    this.audio = new Audio(simple_sms);

    this.api = new MiCompAPI(null);
    setInterval(() => {
      if (this.state.ufdMessages.length > 0) {
        this.setState({ ufdMessages: this.state.ufdMessages.slice(1) });
      }
    }, 10000);
  }
  componentDidMount() {
    this.GetNotifications();
    this.GetUserTokenandIdentitybyId(0, async (loginuser) => {
      if (loginuser) {
        try {
          this.setState({
            loginuser: loginuser,
          });
          let { userPermandMasters } = this.props;
          const { decodedToken } = userPermandMasters;
          const tokenCredential = new AzureCommunicationTokenCredential(
            loginuser.userAccessToken
          );
          this.tokenCredential = tokenCredential;
          this.chatClient = new ChatClient(
            loginuser.acsEndpoint,
            tokenCredential
          );

          this.callClient = new CallClient({
            diagnostics: {
              appName: "azure-communication-services",
              appVersion: "1.3.1-beta.1",
              tags: ["javascript_calling_sdk", `#clientTag:${uuid()}`],
            },
          });
          this.environmentInfo =
            await this.callClient.getEnvironmentInfoInternal();
          this.debugInfoFeature = await this.callClient.feature(
            Features.DebugInfo
          );
          this.callAgent = await this.callClient.createCallAgent(
            tokenCredential,
            { displayName: decodedToken.UserProfileName }
          );
          this.deviceManager = await this.callClient.getDeviceManager();
          const permissions = await this.deviceManager.askDevicePermission({
            audio: true,
            video: true,
          });
          this.setState({ permissions: permissions });

          this.callAgent.on("callsUpdated", (e) => {
            e.added.forEach((call) => {
              this.setState({ call: call });

              const diagnosticChangedListener = (diagnosticInfo) => {
                const rmsg = `UFD Diagnostic changed:
                    Diagnostic: ${diagnosticInfo.diagnostic}
                    Value: ${diagnosticInfo.value}
                    Value type: ${diagnosticInfo.valueType}`;
                if (this.state.ufdMessages.length > 0) {
                  this.setState({
                    ufdMessages: [...this.state.ufdMessages, rmsg],
                  });
                } else {
                  this.setState({ ufdMessages: [rmsg] });
                }
              };

              call
                .feature(Features.UserFacingDiagnostics)
                .media.on("diagnosticChanged", diagnosticChangedListener);
              call
                .feature(Features.UserFacingDiagnostics)
                .network.on("diagnosticChanged", diagnosticChangedListener);
            });

            e.removed.forEach((call) => {
              if (this.state.call && this.state.call === call) {
                this.displayCallEndReason(this.state.call.callEndReason);
              }
            });
          });
          this.callAgent.on("incomingCall", (args) => {
            const incomingCall = args.incomingCall;
            this.audio.loop = true;
            this.audio.play();
            if (this.state.call) {
              incomingCall.reject();
              return;
            }

            this.setState({ incomingCall: incomingCall });

            incomingCall.on("callEnded", (args) => {
              this.audio.pause();
              this.displayCallEndReason(args.callEndReason);
            });
          });
          this.setState({
            isCallClientActiveInAnotherTab:
              this.debugInfoFeature.isCallClientActiveInAnotherTab,
          });
          this.debugInfoFeature.on(
            "isCallClientActiveInAnotherTabChanged",
            () => {
              this.setState({
                isCallClientActiveInAnotherTab:
                  this.debugInfoFeature.isCallClientActiveInAnotherTab,
              });
            }
          );
        } catch (e) {
          console.error(e);
        }
      }
    });
  }
  displayCallEndReason = (callEndReason) => {
    if (callEndReason.code !== 0 || callEndReason.subCode !== 0) {
      message.destroy();
      message.error(
        `Call end reason: code: ${callEndReason.code}, subcode: ${callEndReason.subCode}`,
        3
      );
    }

    this.setState({ call: undefined, incomingCall: undefined });
  };
  getCallOptions = async (withVideo) => {
    let callOptions = {
      videoOptions: {
        localVideoStreams: undefined,
      },
      audioOptions: {
        muted: false,
      },
    };

    let cameraWarning = undefined;
    let speakerWarning = undefined;
    let microphoneWarning = undefined;

    // On iOS, device permissions are lost after a little while, so re-ask for permissions
    const permissions = await this.deviceManager.askDevicePermission({
      audio: true,
      video: true,
    });
    this.setState({ permissions: permissions });

    const cameras = await this.deviceManager.getCameras();
    const cameraDevice = cameras[0];
    if (cameraDevice && cameraDevice.id !== "camera:") {
      this.setState({
        selectedCameraDeviceId: cameraDevice.id,
        cameraDeviceOptions: cameras.map((camera) => {
          return { key: camera.id, text: camera.name };
        }),
      });
    }
    if (withVideo) {
      try {
        if (!cameraDevice || cameraDevice.id === "camera:") {
          throw new Error("No camera devices found.");
        } else if (cameraDevice) {
          callOptions.videoOptions = {
            localVideoStreams: [new LocalVideoStream(cameraDevice)],
          };
          if (this.videoConstraints) {
            callOptions.videoOptions.constraints = this.videoConstraints;
          }
        }
      } catch (e) {
        cameraWarning = e.message;
      }
    }

    try {
      const speakers = await this.deviceManager.getSpeakers();
      const speakerDevice = speakers[0];
      if (!speakerDevice || speakerDevice.id === "speaker:") {
        throw new Error("No speaker devices found.");
      } else if (speakerDevice) {
        this.setState({
          selectedSpeakerDeviceId: speakerDevice.id,
          speakerDeviceOptions: speakers.map((speaker) => {
            return { key: speaker.id, text: speaker.name };
          }),
        });
        await this.deviceManager.selectSpeaker(speakerDevice);
      }
    } catch (e) {
      speakerWarning = e.message;
    }

    try {
      const microphones = await this.deviceManager.getMicrophones();
      const microphoneDevice = microphones[0];
      if (!microphoneDevice || microphoneDevice.id === "microphone:") {
        throw new Error("No microphone devices found.");
      } else {
        this.setState({
          selectedMicrophoneDeviceId: microphoneDevice.id,
          microphoneDeviceOptions: microphones.map((microphone) => {
            return { key: microphone.id, text: microphone.name };
          }),
        });
        await this.deviceManager.selectMicrophone(microphoneDevice);
      }
    } catch (e) {
      microphoneWarning = e.message;
    }

    if (cameraWarning || speakerWarning || microphoneWarning) {
      message.destroy();
      message.warning(
        `${cameraWarning ? cameraWarning + " " : ""}
      ${speakerWarning ? speakerWarning + " " : ""}
      ${microphoneWarning ? microphoneWarning + " " : ""}`,
        3
      );
    }

    return callOptions;
  };

  runPreCallDiagnostics = async () => {
    try {
      this.setState({
        showPreCallDiagnostcisResults: false,
        isPreCallDiagnosticsCall: true,
        preCallDiagnosticsResults: {},
      });
      const preCallDiagnosticsResult = await this.callClient
        .feature(Features.PreCallDiagnostics)
        .startTest(this.tokenCredential);

      const deviceAccess = await preCallDiagnosticsResult.deviceAccess;
      this.setState({
        preCallDiagnosticsResults: {
          ...this.state.preCallDiagnosticsResults,
          deviceAccess,
        },
      });

      const deviceEnumeration =
        await preCallDiagnosticsResult.deviceEnumeration;
      this.setState({
        preCallDiagnosticsResults: {
          ...this.state.preCallDiagnosticsResults,
          deviceEnumeration,
        },
      });

      const inCallDiagnostics =
        await preCallDiagnosticsResult.inCallDiagnostics;
      this.setState({
        preCallDiagnosticsResults: {
          ...this.state.preCallDiagnosticsResults,
          inCallDiagnostics,
        },
      });

      const browserSupport = await preCallDiagnosticsResult.browserSupport;
      this.setState({
        preCallDiagnosticsResults: {
          ...this.state.preCallDiagnosticsResults,
          browserSupport,
        },
      });

      this.setState({
        showPreCallDiagnostcisResults: true,
        isPreCallDiagnosticsCall: false,
      });
    } catch {
      throw new Error(
        "Can't run Pre Call Diagnostics test. Please try again..."
      );
    }
  };
  placeCall = async (identitiesToCall, withVideo, thread) => {
    try {
      const callOptions = await this.getCallOptions(withVideo);
      this.GetallAzureThreads(thread);
      this.callAgent.startCall(identitiesToCall, callOptions);
    } catch (e) {
      console.error("Failed to place a call", e);
      message.destroy();
      message.error("Failed to place a call: " + e, 3);
    }
  };
  GetallAzureThreads(thread) {
    this.api.invoke("GetallAzureThreads", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          if (data.data && data.data.length > 0) {
            const threadData = data.data.filter(
              (item) => item.threadId === thread.threadId
            );
            this.setState({
              thread: threadData,
            });
          }
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }
  GetUserTokenandIdentitybyId = (id, callback) => {
    this.api.invoke(
      "GetUserTokenandIdentitybyId/" + id,
      "get",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this._identityClient = new CommunicationIdentityClient(
              "endpoint=" +
                data.data.acsEndpoint +
                ";accesskey=" +
                data.data.acsAccesskey
            );
            if (
              data.data &&
              (!data.data.userIdentity || data.data.userIdentity === "") &&
              (!data.data.userAccessToken || data.data.userAccessToken === "")
            ) {
              createUser(this._identityClient).then((user) => {
                if (id === 0) {
                  getToken(user, this._identityClient).then((token) => {
                    this.SetUserTokenandIdentity({
                      id: id,
                      userIdentity: user.communicationUserId,
                      userAccessToken: token.token,
                      endTime: token.expiresOn,
                    });
                    data.data.userIdentity = user.communicationUserId;
                    data.data.userAccessToken = token.token;
                    data.data.endTime = token.expiresOn;
                  });
                } else {
                  this.SetUserTokenandIdentity({
                    id: id,
                    userIdentity: user.communicationUserId,
                  });
                  data.data.userIdentity = user.communicationUserId;
                }
              });
            } else if (
              id === 0 &&
              ((data.data &&
                (!data.data.userAccessToken ||
                  data.data.userAccessToken === "")) ||
                moment().diff(moment(data.data.EndTime), "minutes") <= 0)
            ) {
              getToken(
                { communicationUserId: data.data.userIdentity },
                this._identityClient
              ).then((token) => {
                this.SetUserTokenandIdentity({
                  id: id,
                  userIdentity: data.data.userIdentity,
                  userAccessToken: token.token,
                  endTime: token.expiresOn,
                });
                data.data.userAccessToken = token.token;
                data.data.endTime = token.expiresOn;
              });
            }
            callback(data.data);
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  };
  SetUserTokenandIdentity = (val) => {
    this.api.invoke(
      "SetUserTokenandIdentity",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      val
    );
  };
  showModal = (tag) => {
    this.setState({
      visible: !this.state.visible,
      notifi: tag,
    });
  };

  GetNotifications() {
    this.api.invoke("GetNotifications", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.setState({
            notification: data.data,
          });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }
  ReadNotificationbyId = (tag) => {
    this.showModal(tag);

    this.api.invoke(
      "ReadNotificationbyId/" + tag.id,
      "patch",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            this.GetNotifications();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      }
    );
  };
  DeleteAllNotifications = () => {
    this.api.invoke("DeleteAllNotifications/", "delete", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          this.GetNotifications();
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  };
  logout = () => {
    this.api.invoke("Logout", "post", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          window.location.pathname = "";
          sessionStorage.clear();
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  };

  switchUsers = () => {
    this.api.invoke("switchUsers", "post", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          sessionStorage.setItem("token", data.data.token);
          sessionStorage.setItem("isprofiledone", data.data.isregistered);
          window.location.reload();
          window.location.pathname = "";
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  };

  navigate = () => {
    let { userPermandMasters } = this.props;
    const { decodedToken } = userPermandMasters;
    var role = decodedToken.UserRoleName;
    if (role === "broker" || role === "agency" || role === "carrier") {
      this.props.history.push("/profile");
    }
  };
  clickHandler() {
    this.setState({
      settingdrawervisible: false,
    });
  }

  render() {
    let navComponents = [];
    let navComponentsR = [];
    let i = 0;
    this.props.userPermandMasters.HeaderMenus.map((item) => {
      let path = item.path === null || item.path === "" ? i++ : item.path;
      navComponents.push(
        <Menu.Item key={path}>
          <Link to={{ pathname: path }}>
            <span>{item.name}</span>
          </Link>
        </Menu.Item>
      );
      return null;
    });
    let { userPermandMasters } = this.props;
    const { decodedToken, Permissions } = userPermandMasters;
    var userProfileName = decodedToken.UserProfileName;
    var role = decodedToken.UserRoleName;
    var isBoth = decodedToken.isBoth;
    if (this.props.userPermandMasters)
      this.props.userPermandMasters.SideRMenus.map((item) => {
        let path = item.path === null || item.path === "" ? i++ : item.path;
        if (item.menuItemModels.length === 0) {
          if (!this.state.collapse)
            navComponentsR.push(
              <Menu.Item
                onClick={() => (document.documentElement.scrollTop = 0)}
                key={path}
              >
                <Link to={{ pathname: path }}>
                  <i className={item.icon} />
                  <span style={{ marginLeft: "5px" }}>{item.name}</span>
                </Link>
              </Menu.Item>
            );
          else
            navComponentsR.push(
              <Menu.Item
                onClick={() => (document.documentElement.scrollTop = 0)}
                style={{ margin: "0px 5px" }}
                key={path}
              >
                <Link to={{ pathname: path }}>
                  <i className={item.icon} />
                  <span style={{ marginLeft: "5px" }}>{item.name}</span>
                </Link>
              </Menu.Item>
            );
        } else {
          let subComponentsBroker = [];
          item.menuItemModels.map((item) => {
            path = item.path === null || item.path === "" ? i++ : item.path;
            subComponentsBroker.push(
              <Menu.Item
                onClick={() => (document.documentElement.scrollTop = 0)}
                key={path}
              >
                <Link to={{ pathname: path }}>
                  <span style={{ marginLeft: "5px" }}>{item.name}</span>{" "}
                </Link>
              </Menu.Item>
            );
            return null;
          });
          if (subComponentsBroker.length) {
            if (!this.state.collapse)
              navComponentsR.push(
                <SubMenu
                  key={path}
                  title={
                    <span>
                      <i className={item.icon} />
                      <span style={{ marginLeft: "5px" }}>{item.name}</span>
                    </span>
                  }
                >
                  {subComponentsBroker}
                </SubMenu>
              );
            else
              navComponentsR.push(
                <SubMenu
                  style={{ margin: "0px 5px" }}
                  key={path}
                  title={
                    <span>
                      <i style={{ marginLeft: "-7px" }} className={item.icon} />
                    </span>
                  }
                >
                  {subComponentsBroker}
                </SubMenu>
              );
          }
        }
        return null;
      });
    return (
      <Router>
        <Layout>
          <Navigation
            userPermandMasters={userPermandMasters}
            collapse={this.state.collapse}
          />
          <Layout>
            <Header className="header">
              {/* <div className="logo1" onClick={this.collapsed}></div> */}
              <Menu
                theme="light"
                mode="horizontal"
                defaultSelectedKeys={["2"]}
                style={{ lineHeight: "64px" }}
                selectedKeys=""
                triggerSubMenuAction="click"
              >
                {navComponents}
                {role !== "carrier" && role !== "member" ? (
                  <Menu.Item key="10">
                    <Link to={{ pathname: "subscription" }}>
                      <span>
                        Subscription{" "}
                        <Tag color="cyan">
                          {Permissions &&
                            Permissions[0] &&
                            Permissions[0].subscription_Type}
                        </Tag>
                      </span>
                    </Link>
                  </Menu.Item>
                ) : (
                  ""
                )}
                {(role === "broker" || role === "member") &&
                  isBoth === "true" && (
                    <Menu.Item key="ismember">
                      <Button
                        htmlType="submit"
                        onClick={this.switchUsers}
                        style={{
                          backgroundColor: "darkslateblue",
                          color: "white",
                        }}
                      >
                        {"Switch Role"}
                      </Button>
                    </Menu.Item>
                  )}

                <SubMenu
                  title={
                    <span
                      style={{
                        color: "var(--main-bg-color)",
                        display: "inline-flex",
                      }}
                    >
                      <i
                        style={{
                          color: "var(--main-bg-color)",
                          marginTop: "16px",
                        }}
                        className="fa-size2  fa fa-user-circle-o"
                      ></i>
                      <div>
                        {userProfileName}
                        <i
                          style={{
                            color: "var(--main-bg-color)",
                            marginLeft: "10px",
                          }}
                          className="fa-size fa fa-chevron-down menuhover"
                          aria-hidden="true"
                        ></i>
                      </div>
                    </span>
                  }
                  style={{
                    float: "right",
                    top: "0px",
                    paddingLeft: "20px",
                  }}
                  key="logout"
                >
                  {role === "broker" || role === "agency" ? (
                    <Menu.Item
                      key="logout1"
                      style={{ borderBottom: "1px solid black" }}
                    >
                      <p>
                        <Link
                          style={{
                            margin: "0px",
                            color: "var(--main-bg-color)",
                          }}
                          to={{ pathname: "/profile" }}
                        >
                          <i
                            className=" fa-margin fa fa-user"
                            aria-hidden="true"
                          ></i>
                          Profile
                        </Link>
                      </p>{" "}
                    </Menu.Item>
                  ) : (
                    ""
                  )}
                  <Menu.Item
                    key="logout3"
                    style={{
                      borderBottom: "1px solid var(--main-bg-color)",
                    }}
                  >
                    <p>
                      <Link
                        style={{
                          margin: "0px",
                          color: "var(--main-bg-color)",
                        }}
                        to={{ pathname: "/resetpassword" }}
                      >
                        {" "}
                        <i
                          className=" fa-margin fa fa-key"
                          aria-hidden="true"
                        ></i>
                        Change Password
                      </Link>
                    </p>
                  </Menu.Item>
                  <Menu.Item key="logout2" onClick={this.logout}>
                    <i
                      className=" fa-margin  fa fa-sign-out"
                      aria-hidden="true"
                    ></i>{" "}
                    Logout
                  </Menu.Item>
                </SubMenu>

                <SubMenu
                  style={{ float: "right" }}
                  title={
                    <Badge
                      count={this.state.notification.count}
                      style={{ marginTop: "0px" }}
                    >
                      <Icon
                        type="bell"
                        style={{
                          fontSize: "18px",
                          color: "rgba(0, 0, 0, 0.65)",
                          height: "35px",
                        }}
                      />
                    </Badge>
                  }
                >
                  <Menu.Item
                    style={{
                      height: "350px",
                      width: "356px",
                      overflowY: "scroll",
                    }}
                  >
                    <Row
                      style={{
                        borderBottom: "3px solid var(--main-bg-color)",
                        marginLeft: "-15px",
                        marginRight: "-15px",
                        marginTop: "-20px",
                      }}
                    >
                      <Col md={18}>
                        <h3
                          style={{
                            color: "rgba(0, 0, 0, 0.65)",
                            margin: "15px 0 -10px 15px",
                            paddingRight: "-20px",
                          }}
                        >
                          Notifications
                        </h3>
                      </Col>
                      <Col md={6}>
                        {this.state.notification &&
                          ((this.state.notification.today &&
                            this.state.notification.today.length > 0) ||
                            (this.state.notification.previous &&
                              this.state.notification.previous.length > 0)) && (
                            <h4
                              onClick={() => {
                                this.DeleteAllNotifications();
                              }}
                              style={{
                                color: "rgba(0, 0, 0, 0.65)",
                                margin: "15px 0 -10px 15px",
                                paddingRight: "-20px",
                              }}
                            >
                              Clear All
                            </h4>
                          )}
                      </Col>
                    </Row>

                    <Row md={24} style={{ marginTop: "-20px" }}>
                      <Col md={24}>
                        <h3
                          style={{
                            marginBottom: "-5px",
                            color: "rgba(0, 0, 0, 0.65)",
                          }}
                        >
                          Today
                        </h3>

                        {this.state.notification.today &&
                        this.state.notification.today.length > 0 ? (
                          this.state.notification.today.map((tag) => (
                            <div
                              style={{
                                color: "rgba(0, 0, 0, 0.65)",
                                borderBottom: "0.5px solid ",
                                marginLeft: "-15px",
                                marginRight: "-15px",
                              }}
                            >
                              {tag.isRead === true ? (
                                <Row
                                  onClick={() => {
                                    this.showModal(tag);
                                  }}
                                  value={tag.id}
                                  key={tag.id}
                                  title={tag.description}
                                >
                                  <Col md={5}>
                                    <Avatar
                                      style={{ marginLeft: "13px" }}
                                      icon={
                                        <div
                                          style={{
                                            backgroundColor:
                                              "var(--main-bg-color)",
                                            height: "100%",
                                            width: "100%",
                                            position: "relative",
                                          }}
                                        >
                                          <i
                                            className={tag.icon}
                                            style={{ marginLeft: "9px" }}
                                          />
                                        </div>
                                      }
                                    />
                                  </Col>
                                  <Col md={19}>
                                    <div style={{ marginBottom: "-21px" }}>
                                      <p
                                        style={{
                                          marginBottom: "px",
                                          fontSize: "15px",
                                          marginTop: "-7px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          width: "250px",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {tag.description}
                                      </p>
                                      <p
                                        style={{
                                          marginTop: "-50px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {moment().diff(
                                          moment(tag.createdOn),
                                          "hour"
                                        ) <= 12
                                          ? moment(tag.createdOn).format("LT")
                                          : moment(tag.createdOn).format("lll")}
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              ) : (
                                <Row
                                  value={tag.id}
                                  onClick={() => this.ReadNotificationbyId(tag)}
                                  key={tag.id}
                                  title={tag.description}
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "lightblue",
                                  }}
                                >
                                  <Col md={5}>
                                    <Avatar
                                      style={{ marginLeft: "13px" }}
                                      icon={
                                        <div
                                          style={{
                                            backgroundColor:
                                              "var(--main-bg-color)",
                                            height: "100%",
                                            width: "100%",
                                            position: "relative",
                                          }}
                                        >
                                          <i
                                            className={tag.icon}
                                            style={{ marginLeft: "9px" }}
                                          />
                                        </div>
                                      }
                                    />
                                  </Col>
                                  <Col md={19}>
                                    <div style={{ marginBottom: "-21px" }}>
                                      <p
                                        style={{
                                          marginBottom: "px",
                                          fontSize: "15px",
                                          marginTop: "-7px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          width: "250px",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {tag.description}
                                      </p>
                                      <p
                                        style={{
                                          marginTop: "-50px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {moment().diff(
                                          moment(tag.createdOn),
                                          "hour"
                                        ) <= 12
                                          ? moment(tag.createdOn).format("LT")
                                          : moment(tag.createdOn).format("lll")}
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              )}
                            </div>
                          ))
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <span style={{ fontStyle: "italic" }}>
                              No new notifications
                            </span>
                          </div>
                        )}

                        <h3
                          style={{
                            marginBottom: "-5px",
                            color: "rgba(0, 0, 0, 0.65)",
                          }}
                        >
                          Earlier
                        </h3>
                        {this.state.notification.previous &&
                        this.state.notification.previous.length > 0 ? (
                          this.state.notification.previous.map((tag, i) => (
                            <div
                              key={i}
                              style={{
                                color: "rgba(0, 0, 0, 0.65)",
                                borderBottom: "0.5px solid ",
                                marginLeft: "-15px",
                                marginRight: "-15px",
                              }}
                            >
                              {tag.isRead === true ? (
                                <Row
                                  onClick={() => {
                                    this.showModal(tag);
                                  }}
                                  value={tag.id}
                                  key={tag.id}
                                  title={tag.description}
                                >
                                  <Col md={5}>
                                    <Avatar
                                      style={{ marginLeft: "13px" }}
                                      icon={
                                        <div
                                          style={{
                                            backgroundColor:
                                              "var(--main-bg-color)",
                                            height: "100%",
                                            width: "100%",
                                            position: "relative",
                                          }}
                                        >
                                          <Icon
                                            type="bell"
                                            style={{ marginLeft: "9px" }}
                                          />
                                        </div>
                                      }
                                    />
                                  </Col>
                                  <Col md={19}>
                                    <div style={{ marginBottom: "-21px" }}>
                                      <p
                                        style={{
                                          marginBottom: "px",
                                          fontSize: "15px",
                                          marginTop: "-7px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          width: "250px",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {tag.description}
                                      </p>
                                      <p
                                        style={{
                                          marginTop: "-50px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {moment().diff(
                                          moment(tag.createdOn),
                                          "hour"
                                        ) <= 12
                                          ? moment(tag.createdOn).format("LT")
                                          : moment(tag.createdOn).format("lll")}
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              ) : (
                                <Row
                                  value={tag.id}
                                  key={tag.id}
                                  onClick={() => this.ReadNotificationbyId(tag)}
                                  title={tag.description}
                                  style={{
                                    fontWeight: "bold",
                                    backgroundColor: "lightblue",
                                    justifycontent: "center",
                                  }}
                                >
                                  <Col md={5}>
                                    <Avatar
                                      style={{ marginLeft: "13px" }}
                                      icon={
                                        <div
                                          style={{
                                            backgroundColor:
                                              "var(--main-bg-color)",
                                            height: "100%",
                                            width: "100%",
                                            position: "relative",
                                          }}
                                        >
                                          <Icon
                                            type="bell"
                                            style={{ marginLeft: "9px" }}
                                          />
                                        </div>
                                      }
                                    />
                                  </Col>
                                  <Col md={19}>
                                    <div style={{ marginBottom: "-21px" }}>
                                      <p
                                        style={{
                                          marginBottom: "px",
                                          marginTop: "-7px",
                                          fontSize: "15px",
                                          whiteSpace: "nowrap",
                                          overflow: "hidden",
                                          width: "250px",
                                          textOverflow: "ellipsis",
                                        }}
                                      >
                                        {tag.description}
                                      </p>
                                      <p
                                        style={{
                                          marginTop: "-50px",
                                          fontSize: "12px",
                                        }}
                                      >
                                        {moment().diff(
                                          moment(tag.createdOn),
                                          "hour"
                                        ) <= 12
                                          ? moment(tag.createdOn).format("LT")
                                          : moment(tag.createdOn).format("lll")}
                                      </p>
                                    </div>
                                  </Col>
                                </Row>
                              )}
                            </div>
                          ))
                        ) : (
                          <div style={{ textAlign: "center" }}>
                            <span style={{ fontStyle: "italic" }}>
                              No new notifications
                            </span>
                          </div>
                        )}
                      </Col>
                    </Row>
                  </Menu.Item>
                </SubMenu>
                <Modal visible={this.state.visible} width="500px">
                  {" "}
                  <div className="mi_model_popup">
                    <Row span={24}>
                      <Col span={18}>
                        <p className="mi_title">
                          {this.state.notifi && this.state.notifi.title}
                        </p>
                      </Col>
                      <Col span={6}>
                        <i
                          className="fa fa-times mi_icon mi_icon_red mi_button_close"
                          style={{ color: "red" }}
                          onClick={() => {
                            this.showModal(null);
                          }}
                        ></i>
                      </Col>
                    </Row>
                    <Row span={24}>
                      <Col sm={24}>
                        <p>
                          {this.state.notifi && this.state.notifi.description}
                        </p>
                      </Col>{" "}
                    </Row>
                    <Row span={24} style={{ marginTop: "20px" }}>
                      <Col span={7}></Col>
                      <Col span={5}>
                        <Button
                          className="mi_button_right"
                          onClick={() => {
                            this.showModal(null);
                          }}
                          style={{ marginRight: 8 }}
                        >
                          Cancel
                        </Button>
                      </Col>
                      <Col span={5}>
                        <Button
                          htmlType="button"
                          type="primary"
                          onClick={() => {
                            this.showModal(null);
                          }}
                        >
                          Ok
                        </Button>
                      </Col>
                      <Col span={7}>
                        <img
                          alt="example"
                          style={{
                            width: 105,
                            marginBottom: "-29px",
                            float: "right",
                          }}
                          src={img}
                        />
                      </Col>
                    </Row>
                  </div>
                </Modal>
              </Menu>
            </Header>
            <div>
              {this.state.settingdrawervisible ? (
                <Button
                  className="ant-btn mi_button_icon_draw"
                  style={{
                    position: "absolute",
                    top: "200px",
                    right: "285px",
                    visibility: "hidden",
                  }}
                  type="primary"
                  onClick={() =>
                    this.setState({
                      settingdrawervisible: false,
                    })
                  }
                >
                  <i
                    className="fa fa-times fa-5x "
                    style={{ color: "#fff" }}
                  ></i>
                </Button>
              ) : (
                <Button
                  className="ant-btn mi_button_icon_draw"
                  style={{ position: "absolute", top: "200px", right: "-10px" }}
                  onClick={() =>
                    this.setState({
                      settingdrawervisible: true,
                    })
                  }
                >
                  <i className="fa fa-cog "></i>
                </Button>
              )}

              <Drawer
                width={"300px"}
                placement="right"
                closable={true}
                onClose={() =>
                  this.setState({
                    settingdrawervisible: false,
                  })
                }
                visible={this.state.settingdrawervisible}
              >
                <Menu
                  style={{ marginTop: "30px" }}
                  mode="inline"
                  className="mi_ant_menu"
                  selectedKeys={[window.location.pathname]}
                  onClick={this.clickHandler.bind(this)}
                >
                  {navComponentsR}
                </Menu>
              </Drawer>
              {/* {
                this.state.ufdMessages.length > 0 &&
                <Modal visible={true} onCancel={()=>{
                  this.setState({
                    ufdMessages:[]
                  })
                }} onOk={()=>{
                  this.setState({
                    ufdMessages:[]
                  })
                }}>
                  {this.state.ufdMessages.map((msg, index) => <li key={index}>{msg}</li>)}

                </Modal>

              } */}

              {this.state.call &&
                this.state.isPreCallDiagnosticsCallInProgress && (
                  <Modal visible={true}>
                    <div>Pre Call Diagnostics call in progress...</div>
                  </Modal>
                )}
              {this.state.call &&
                !this.state.isPreCallDiagnosticsCallInProgress && (
                  <div style={{ backgroundColor: "white" }}>
                    <CallCard
                      audio={this.audio}
                      call={this.state.call}
                      thread={this.state.thread}
                      loginuser={this.state.loginuser}
                      GetUserTokenandIdentitybyId={
                        this.GetUserTokenandIdentitybyId
                      }
                      chatClient={this.chatClient}
                      serverCallId={this.serverCallId}
                      deviceManager={this.deviceManager}
                      selectedCameraDeviceId={this.state.selectedCameraDeviceId}
                      cameraDeviceOptions={this.state.cameraDeviceOptions}
                      speakerDeviceOptions={this.state.speakerDeviceOptions}
                      microphoneDeviceOptions={
                        this.state.microphoneDeviceOptions
                      }
                      userPermandMasters={userPermandMasters}
                      onShowCameraNotFoundWarning={(show) => {
                        this.setState({ showCameraNotFoundWarning: show });
                      }}
                      onShowSpeakerNotFoundWarning={(show) => {
                        this.setState({ showSpeakerNotFoundWarning: show });
                      }}
                      onShowMicrophoneNotFoundWarning={(show) => {
                        this.setState({ showMicrophoneNotFoundWarning: show });
                      }}
                    />
                  </div>
                )}
              {
                this.state.incomingCall && !this.state.call && (
                  // <Modal visible={true} >
                  <IncomingCallCard
                    audio={this.audio}
                    incomingCall={this.state.incomingCall}
                    acceptCallOptions={async () => await this.getCallOptions()}
                    acceptCallWithVideoOptions={async () =>
                      await this.getCallOptions(true)
                    }
                    onReject={() => {
                      this.setState({ incomingCall: undefined });
                    }}
                  />
                )

                // </Modal>
              }
            </div>
            <Switch>
              <Route
                exact
                path="/administration/invoiceadjustment"
                render={(props) => (
                  <InvoiceAdjustment
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/"
                render={(props) => (
                  <Dashboard
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/administration/compliance"
                key="/administration/compliance"
                render={(props) => (
                  <ComplianceTab
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/contracts"
                render={(props) => (
                  <AllContracts
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />

              <Route
                exact
                path="/subscription"
                render={(props) => (
                  <Subscription
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/eligibility"
                render={(props) => (
                  <NiprEligibility
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/add/agency"
                render={(props) => (
                  <InviteLaunchPad
                    {...props}
                    userPermandMasters={userPermandMasters}
                    type="agency"
                    forceValidate={true}
                  />
                )}
              />
              <Route
                exact
                path="/agencies/:agencyId"
                render={(props) => (
                  <Agency {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                exact
                path="/brokers/:brokerId"
                render={(props) => (
                  <Broker {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                exact
                path="/add/broker"
                render={(props) => (
                  <InviteLaunchPad
                    {...props}
                    type="broker"
                    userPermandMasters={userPermandMasters}
                    forceValidate={true}
                  />
                )}
              />
              <Route
                exact
                path="/add/user"
                render={(props) => (
                  <InviteLaunchPad
                    {...props}
                    type="user"
                    userPermandMasters={userPermandMasters}
                    forceValidate={true}
                  />
                )}
              />
              <Route
                path="/transactions"
                exact
                render={(props) => (
                  <Transactions
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/mybusiness"
                exact
                render={(props) => (
                  <Contracts
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/mybusiness"
                key="/mybook"
                exact
                render={(props) => (
                  <Book {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                path="/administration/taxprofile"
                exact
                render={(props) => (
                  <TaxProfile
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/myplans"
                exact
                render={(props) => (
                  <MyPlans {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                path="/profile"
                exact
                render={(props) => (
                  <MyProfile
                    {...props}
                    userPermandMasters={this.props.userPermandMasters}
                  />
                )}
              />
              <Route
                path="/finance"
                exact
                render={(props) => (
                  <Finance
                    {...props}
                    userPermandMasters={this.props.userPermandMasters}
                  />
                )}
              />
              <Route
                path="/settings"
                exact
                render={(props) => (
                  <Settings
                    {...props}
                    userPermandMasters={this.props.userPermandMasters}
                  />
                )}
              />
              <Route
                path="/about"
                exact
                render={(props) => (
                  <About {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                path="/help"
                exact
                render={(props) => (
                  <Help {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                path="/reports/outstandagency"
                exact
                render={(props) => (
                  <AgencyOutstandingPayment
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/outstandbroker"
                exact
                render={(props) => (
                  <BrokerOutstandingPayment
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/outstand"
                exact
                render={(props) => (
                  <OutstandingPayment
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/agencycomm"
                exact
                render={(props) => (
                  <AgencyCommission
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/brokercomm"
                exact
                render={(props) => (
                  <BrokerCommission
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/recon"
                exact
                render={(props) => (
                  <BrokerAgencyRecon
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/summy"
                exact
                render={(props) => (
                  <ClientSummary
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/enroll"
                exact
                render={(props) => (
                  <EnrollmentSummary
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/comm"
                exact
                render={(props) => (
                  <Commission
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/agencycompliance"
                exact
                render={(props) => (
                  <AgencyComplianceMissing
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/brokercompliance"
                exact
                render={(props) => (
                  <BrokerComplianceMissing
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/compliancemissing"
                exact
                render={(props) => (
                  <ComplianceMissing
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/agencylicense"
                exact
                render={(props) => (
                  <AgencyComplianceLicense
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/brokerlicense"
                exact
                render={(props) => (
                  <BrokerComplianceLicense
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/onboarding"
                exact
                render={(props) => (
                  <OnboardingDetails
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/compliance"
                exact
                render={(props) => (
                  <PendingComplianceReport
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/compliancexpiration"
                exact
                render={(props) => (
                  <ComplianceLicenseExpiration
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/reports/premiumvsmem"
                exact
                render={(props) => (
                  <PremiumVSmembers
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/resetpassword"
                exact
                render={(props) => (
                  <ResetPassword
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/administration/reports"
                exact
                render={(props) => (
                  <ManageReports
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/administration/managecompliance"
                exact
                render={(props) => (
                  <ManageCompliance
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/tier/addprofile/:client_id/:tier_id"
                exact
                render={(props) => (
                  <AddTierandProfile
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/tierandprofile"
                render={(props) => (
                  <ClientProfile
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/tierandprofile/:clientId"
                render={(props) => (
                  <Client
                    {...props}
                    isprofile={true}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/usermanagement"
                render={(props) => (
                  <UserManagement
                    {...props}
                    userPermandMasters={userPermandMasters}
                    forceValidate={true}
                  />
                )}
              />
              <Route
                exact
                path="/bq"
                render={(props) => (
                  <Questions
                    {...props}
                    userPermandMasters={userPermandMasters}
                    forceValidate={true}
                  />
                )}
              />
              <Route
                exact
                path="/bgquestions"
                render={(props) => (
                  <BackgroundQuestion
                    {...props}
                    userPermandMasters={userPermandMasters}
                    forceValidate={true}
                  />
                )}
              />
              <Route
                exact
                path="/ssquestion"
                render={(props) => (
                  <StateSpecificQuestion
                    {...props}
                    userPermandMasters={userPermandMasters}
                    forceValidate={true}
                  />
                )}
              />

              <Route
                exact
                path="/mynipr"
                render={(props) => (
                  <MyNipr {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                exact
                path="/niprpayment"
                render={(props) => (
                  <NiprPayment
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/payment"
                render={(props) => (
                  <Paypal {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                exact
                path="/subpayment"
                render={(props) => (
                  <SubscriptionPaypal
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/member"
                render={(props) => (
                  <Producermember
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/family"
                render={(props) => (
                  <Family {...props} userPermandMasters={userPermandMasters} />
                )}
              />
              <Route
                exact
                path="/enrollments"
                render={(props) => (
                  <Enrollment
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/planchange"
                render={(props) => (
                  <PlanChange
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/teams"
                render={(props) =>
                  this.chatClient && this.callClient ? (
                    <Collaboration
                      {...props}
                      chatClient={this.chatClient}
                      placeCall={this.placeCall}
                      loginuser={this.state.loginuser}
                      GetUserTokenandIdentitybyId={
                        this.GetUserTokenandIdentitybyId
                      }
                      userPermandMasters={userPermandMasters}
                    />
                  ) : (
                    <Content>
                      <div className="mi_main_div">
                        <Content>
                          <Skeleton avatar paragraph={{ rows: 4 }} />
                          <Skeleton avatar paragraph={{ rows: 4 }} />
                          <Skeleton avatar paragraph={{ rows: 4 }} />
                        </Content>
                      </div>
                    </Content>
                  )
                }
              />
              <Route
                exact
                path="/administration/managefields"
                render={(props) => (
                  <ManageFields
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/administration/manageevent"
                render={(props) => (
                  <ManageEvent
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/administration/managetriggers"
                render={(props) => (
                  <ManageTriggers
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/administration/managetemplate"
                render={(props) => (
                  <TemplateManagement
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/administration/brokerofrecord"
                render={(props) => (
                  <BrokerProfile
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/addTemplate"
                exact
                render={(props) => (
                  <AddTemplate
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/discussions"
                render={(props) => (
                  <Discussion
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/notificationsettings"
                render={(props) => (
                  <NotificationSettings
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/providersearch"
                render={(props) => (
                  <Providerssearch
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />

              <Route
                exact
                path="/viewTemplate"
                render={(props) => (
                  <ViewTemplate
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/myrequests"
                render={(props) => (
                  <ServiceRequest
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/requestView"
                render={(props) => (
                  <RequestView
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/addRequest"
                render={(props) => (
                  <AddRequest
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/enquiry"
                render={(props) => (
                  <MemberEnquiry
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/commission"
                render={(props) => (
                  <ContractCarrier
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/commissioncenter"
                render={(props) => (
                  <CommissionCenter
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                path="/addenquiry"
                exact
                render={(props) => (
                  <AddEnquiry
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/brokerenquiry"
                render={(props) => (
                  <BrokerEnquiry
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
              <Route
                exact
                path="/addRequestTemplate"
                render={(props) => (
                  <AddRequestTemplate
                    {...props}
                    userPermandMasters={userPermandMasters}
                  />
                )}
              />
            </Switch>
          </Layout>
        </Layout>
      </Router>
    );
  }
}
export default Routes;
